import { render, staticRenderFns } from "./ButtonsField.vue?vue&type=template&id=51d6531a&"
import script from "./ButtonsField.vue?vue&type=script&lang=js&"
export * from "./ButtonsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports